/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/


export enum PartNumberChangesPageTypeEnum {
    CREATE = 'CREATE',
    DETAIL = 'DETAIL'
}
